import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p419606232426328064',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
